import axios from "axios"
import { DashboardType } from "../models/dashboard";
import { Base } from "../models/base";

const endpoint = "/api/data_statistic/personal_info"

export const getDataDashboard = async ( year?: number) => {
    const res = await axios.get<Base<DashboardType>>(`${endpoint}${year ? `?year=${year}` : ''}`);
    return res?.data?.data as DashboardType
}